(function () {
  if (window.__qaQuickView) return;
  window.__qaQuickView = true;

  var modal, body, lastFocus;
  var cache = {};
  var root = (window.theme && theme.routes && theme.routes.root) || '/';

  // Remove duplicate eyes / buttons inside one card
  var dedupeQueued = false;
  function qaDedupe() {
    dedupeQueued = false;
    document.querySelectorAll('.product-block, .carousel-item').forEach(function (b) {
      ['.qa-quickview', '.qa-form'].forEach(function (s) {
        var n = b.querySelectorAll(s);
        for (var i = 1; i < n.length; i++) n[i].remove();
      });
    });
  }
  function queueDedupe() {
    if (dedupeQueued) return;
    dedupeQueued = true;
    requestAnimationFrame(qaDedupe);
  }
  document.addEventListener('DOMContentLoaded', function () {
    qaDedupe();
    new MutationObserver(queueDedupe).observe(document.body, { childList: true, subtree: true });
  });

  function build() {
    modal = document.createElement('div');
    modal.className = 'qa-modal';
    modal.innerHTML =
      '<div class="qa-modal__box" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '<button type="button" class="qa-modal__x" aria-label="Close">&times;</button>' +
      '<div class="qa-modal__body"></div></div>';
    document.body.appendChild(modal);
    body = modal.querySelector('.qa-modal__body');
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.qa-modal__x')) close();
      var thumb = e.target.closest('.qa-gallery__thumb');
      if (thumb) selectThumb(thumb);
    });
  }

  function open() {
    document.body.style.overflow = 'hidden';
    document.body.classList.add('qa-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
    });
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('qa-open');
    setTimeout(function () { if (!modal.classList.contains('is-open')) body.innerHTML = ''; }, 350);
    if (lastFocus) lastFocus.focus();
  }

  function selectThumb(thumb) {
    var gallery = thumb.closest('.qa-gallery');
    gallery.querySelector('.qa-gallery__main img').src = thumb.getAttribute('data-src');
    gallery.querySelectorAll('.qa-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '?section_id=api-quickview')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var content = tmp.querySelector('[data-api-content]');
          if (!content) throw new Error('no content');
          return content.innerHTML;
        });
      cache[handle].catch(function () { delete cache[handle]; });
    }
    return cache[handle];
  }

  function fullImage(url) {
    if (!url) return url;
    url = url.replace(/([?&])crop=[^&]*/g, '$1')
             .replace(/([?&])height=[^&]*/g, '$1')
             .replace(/([?&])width=[^&]*/g, '$1');
    url = url.replace(/[?&]+$/, '').replace(/\?&/, '?').replace(/&&+/g, '&');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=900';
  }

  function enhance(handle) {
    var media = body.querySelector('.quickview-media');
    var imgs = media ? media.querySelectorAll('img') : [];
    if (media && imgs.length) {
      var srcs = Array.prototype.map.call(imgs, function (i) { return fullImage(i.getAttribute('src')); });
      var title = (body.querySelector('.product__title a') || {}).textContent || '';
      var html = '<div class="qa-gallery__main"><img src="' + srcs[0] + '" alt="' + title.replace(/"/g, '&quot;') + '"></div>';
      if (srcs.length > 1) {
        html += '<div class="qa-gallery__thumbs">' + srcs.map(function (s, i) {
          return '<button type="button" class="qa-gallery__thumb' + (i === 0 ? ' is-active' : '') +
                 '" data-src="' + s + '" aria-label="Image ' + (i + 1) + '"><img src="' + s + '" alt=""></button>';
        }).join('') + '</div>';
      }
      var gallery = document.createElement('div');
      gallery.className = 'qa-gallery';
      gallery.innerHTML = html;
      media.parentNode.replaceChild(gallery, media);
    }

    try {
      var v = JSON.parse(body.querySelector('script[data-selected-variant]').textContent);
      if (v.available) {
        var notify = body.querySelector('.product-soldout-notification');
        if (notify) notify.remove();
      }
    } catch (e) {}

    var atc = body.querySelector('[data-add-to-cart]');
    var pre = body.querySelector('[data-product-preorder]');
    if (pre && atc && atc.getAttribute('data-preorder') !== 'true') pre.remove();

    var info = body.querySelector('.product__info__wrapper');
    if (info) {
      var a = document.createElement('a');
      a.className = 'qa-full-link';
      a.href = root + 'products/' + handle;
      a.textContent = 'View full details';
      info.appendChild(a);
    }
  }

  function preload(e) {
    var btn = e.target.closest && e.target.closest('[data-qa-quickview]');
    if (btn) fetchProduct(btn.getAttribute('data-qa-quickview')).catch(function () {});
  }
  document.addEventListener('mouseover', preload);
  document.addEventListener('touchstart', preload, { passive: true });

  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qa-quickview]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (!modal) build();
    lastFocus = btn;
    var handle = btn.getAttribute('data-qa-quickview');

    body.innerHTML = '<div class="qa-modal__loading"><div class="qa-spinner"></div>Loading...</div>';
    open();

    fetchProduct(handle)
      .then(function (html) {
        body.innerHTML = html;
        enhance(handle);
        modal.querySelector('.qa-modal__x').focus();
      })
      .catch(function () {
        body.innerHTML = '<div class="qa-modal__loading">Unable to load this product. Please try again.</div>';
      });
  });
})();